const slidesSelector = (state, slideIds) => {
  let slides = []

  if (slideIds) {
    slideIds.forEach((id) => {
      slides.push(state['slides'][id])
    })
  }

  return slides
}

export default slidesSelector



// WEBPACK FOOTER //
// ./src/selectors/slides.js